module.exports = __webpack_public_path__ + "img/pro_one_9.8d18720d.jpg";